import React from 'react';
import { Icon, Table, CardDescription, Label } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';

export const ProjectsListItem = ({ project, showValidated, showEdit }) => {
  return (
    <Table.Row>
      <Table.Cell textAlign='center'>{project.id}</Table.Cell>
      <Table.Cell>
        <CardDescription as={NavLink} to={`/cases/${project.id}`}>
          {project.properties.name}
        </CardDescription>
      </Table.Cell>
      <Table.Cell textAlign='center'>{project.properties.municipality || '—'}</Table.Cell>
      {showValidated && (
        <Table.Cell textAlign='center'>
          {project.properties.validated
            ? <Label color='green' size='small'><Icon name='check' />Validated</Label>
            : <Label color='orange' size='small'><Icon name='clock' />Pending</Label>}
        </Table.Cell>
      )}
      {showEdit && (
        <Table.Cell textAlign='center'>
          <NavLink to={`/case/update/${project.id}`}>
            <Icon name='pencil' />
          </NavLink>
        </Table.Cell>
      )}
    </Table.Row>
  );
};
